class ProductInformationCarouselComponent extends HTMLElement {
  constructor() {
    super();
    this.modal = null;
    this.slideshow = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.modal = this.querySelector('.product-information-carousel__modal');
    this.slideshow = this.querySelector('slideshow-component[ref="productInfoCarousel"]');

    if (!this.modal || !this.slideshow) return;

    this.setupEventListeners();
    this.setupHotspotPositioning();
  }
  

  setupEventListeners() {
    // Tab controls
    this.querySelectorAll('.product-information-carousel__text-control').forEach((button, index) => {
      button.addEventListener('click', () => this.handleTabClick(index));
    });

    // Hotspot clicks - event delegation
    this.addEventListener('click', (e) => {
      const target = e.target;
      if (target instanceof HTMLElement && target.classList.contains('product-information-carousel__hotspot')) {
        e.preventDefault();
        this.handleHotspotClick(target);
      }
    });

    // Modal close
    const closeButton = this.modal?.querySelector('.product-information-carousel__modal-close');
    if (closeButton) {
      closeButton.addEventListener('click', () => this.closeModal());
    }

    // Close on backdrop click
    this.modal?.addEventListener('click', (e) => {
      if (e.target === this.modal) this.closeModal();
    });

    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal?.hasAttribute('open')) {
        this.closeModal();
      }
    });

    // Slideshow changes
    if (this.slideshow) {
      this.slideshow.addEventListener('slideshow:select', (e) => {
        this.handleSlideChange(e.detail?.index);
      });
    }
  }

  handleTabClick(index) {
    // Update tab states
    this.querySelectorAll('.product-information-carousel__text-control').forEach((button, i) => {
      button.setAttribute('aria-selected', i === index ? 'true' : 'false');
    });

    // Navigate slideshow
    if (this.slideshow && 'select' in this.slideshow) {
      this.slideshow.select(index);
    }
  }

  handleSlideChange(index) {
    // Update tab states
    this.querySelectorAll('.product-information-carousel__text-control').forEach((button, i) => {
      button.setAttribute('aria-selected', i === index ? 'true' : 'false');
    });
  }


  handleHotspotClick(hotspot) {
    const title = hotspot.dataset?.hotspotTitle;
    const description = hotspot.dataset?.hotspotDescription;
    const imageUrl = hotspot.dataset?.hotspotImage;

    if (!title && !description) return;

    this.openModal(title, description, imageUrl);
  }

  openModal(title, description, imageUrl) {
    if (!this.modal) return;

    // Update content
    const titleEl = this.modal.querySelector('.product-information-carousel__modal-title');
    const descEl = this.modal.querySelector('.product-information-carousel__modal-description');
    const imgEl = this.modal.querySelector('.product-information-carousel__modal-image');

    if (titleEl) titleEl.textContent = title || '';
    if (descEl) descEl.textContent = description || '';
    
    if (imgEl instanceof HTMLImageElement) {
      if (imageUrl) {
        imgEl.src = imageUrl;
        imgEl.alt = title || '';
        imgEl.style.display = 'block';
      } else {
        imgEl.style.display = 'none';
      }
    }

    // Open modal
    if (this.modal instanceof HTMLDialogElement) {
      this.modal.showModal();
    }
    document.body.style.overflow = 'hidden';
  }

  closeModal() {
    if (!this.modal || !this.modal.hasAttribute('open')) return;
    
    if (this.modal instanceof HTMLDialogElement) {
      this.modal.close();
    }
    document.body.style.overflow = '';
  }

  setupHotspotPositioning() {
    const adjustHotspots = () => {
      if (window.innerWidth <= 749) return;

      const slides = this.slideshow.querySelectorAll('slideshow-slide');
      slides.forEach(slide => {
        const hotspots = slide.querySelectorAll('.product-information-carousel__hotspot');
        const slideRect = slide.getBoundingClientRect();

        const referenceWidth = 1028;
        const currentWidth = slideRect.width;
        const scaleFactor = referenceWidth / currentWidth;

        hotspots.forEach(hotspot => {
          const originalLeft = parseFloat(hotspot.style.getPropertyValue('--hotspot-x-desktop')) || 50;
          const adjustedLeft = 50 + (originalLeft - 50) * scaleFactor;
          hotspot.style.left = adjustedLeft + '%';
        });
      });
    };

    adjustHotspots();
    window.addEventListener('resize', adjustHotspots);
  }
}

// Register component
if (!customElements.get('product-information-carousel-component')) {
  customElements.define('product-information-carousel-component', ProductInformationCarouselComponent);
}

export default ProductInformationCarouselComponent;